import { render } from "./AppSearch.vue?vue&type=template&id=3d89f074&scoped=true&ts=true"
import script from "./AppSearch.vue?vue&type=script&lang=ts"
export * from "./AppSearch.vue?vue&type=script&lang=ts"

import "./AppSearch.vue?vue&type=style&index=0&id=3d89f074&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d89f074"]])

export default __exports__